import { RowDataBdayVoucher } from "../../components/VoucherBirthdayPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the VoucherTable factory
 */
class VoucherBdayRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/bday-voucher/read-range"
        this.accessData = "vouchers"
    }

    create(voucher: any): RowDataBdayVoucher {
        const rowDataBdayVoucher: RowDataBdayVoucher = {
            voucher_id: voucher.voucher_id,
            uid: voucher.uid,
            xid: voucher.xid,
            title: voucher.title,
            type: voucher.type,
            amount: voucher.amount,
            remarks: voucher.remarks,
            startDate: voucher.startDate,
            endDate: voucher.endDate,
            xCode: voucher.xcode,
            xRedemptionID: voucher.xredemptionId,
            xRedemptionType: voucher.xredemptionType,
            cost: voucher.cost,
            imageSrc: voucher.imgSrc,
            status: voucher.status,
            terms_id: voucher.terms_id,
            numVouchers: "",
            numberOfVoucher: voucher.numberOfVoucher,
            numberOfClaimedVoucher: voucher.numberOfClaimedVoucher,
            action: "",

            fullname: voucher.fullname,
            dob: voucher.dob,
            phone_number: voucher.phone_number,
        };
        return rowDataBdayVoucher;
    }
}

let voucherBdayRow: VoucherBdayRow | null = null;

export default function getVoucherBdayRow(): VoucherBdayRow {
    if (voucherBdayRow === null)
        voucherBdayRow = new VoucherBdayRow()
    return voucherBdayRow
}